import cn from 'classnames';
import { format } from 'date-fns';

import { SquareWithRoundBordersShape } from '../SquareWithRoundBordersShape';
import { graphCurrencyFormatter, graphNumberFormatter } from '../utils';
import { useShortDateInTooltip } from '../../../utils/analytics';
import { DATE_FORMAT_US } from '../../../constants/dateFormats';

import styles from './graph-tooltips.module.scss';

export function SalesByTopChannelsTooltip({ data: allData, isGmvMetric, currency }) {
  const formatValue = ({ value, formatAsGmv }) =>
    formatAsGmv ? graphCurrencyFormatter(value, currency) : graphNumberFormatter(value);

  const useShortDate = useShortDateInTooltip(allData);

  return ({ slice: { points } }) => {
    const firstPointData = points[0].data;
    const formattedDate = useShortDate ? firstPointData.x : format(firstPointData.fullDate, DATE_FORMAT_US);

    return (
      <div className={cn(styles.tooltipWrapper, styles.salesByTopChannelsTooltip)}>
        <header>{formattedDate}</header>
        <main>
          <table>
            <tbody>
              {points.map((point) => {
                const { id, color, serieId, data } = point;
                const currentOtherData = allData[isGmvMetric ? 'units' : 'gmv'].find((datum) => datum.id === serieId);
                const currentOtherDatum = currentOtherData.data.find((datum) => datum.x === data.x);

                return (
                  <tr key={id}>
                    <td>
                      <svg height="14" width="14">
                        <SquareWithRoundBordersShape fill={color} />
                      </svg>
                      {serieId}
                    </td>
                    <td>
                      <strong>{formatValue({ value: data.y, formatAsGmv: isGmvMetric })}</strong>
                    </td>
                    <td>({formatValue({ value: currentOtherDatum.y, formatAsGmv: !isGmvMetric })})</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </main>
      </div>
    );
  };
}
